import { getGygPartnerId } from '@/config/bookingExperience';

const GYG_SEARCH_BASE_URL = 'https://www.getyourguide.com/s/';

export interface BuildGygDeepLinkUrlParams {
  searchQuery: string;
  cmp: string;
  partnerId?: string | null;
}

/**
 * Builds a GetYourGuide affiliate search deep link with partner_id, q, and cmp.
 */
export function buildGygDeepLinkUrl(params: BuildGygDeepLinkUrlParams): string | null {
  const partnerId = params.partnerId ?? getGygPartnerId();
  const searchQuery = params.searchQuery?.trim();
  const cmp = params.cmp?.trim();

  if (!partnerId || !searchQuery || !cmp) {
    return null;
  }

  const url = new URL(GYG_SEARCH_BASE_URL);
  url.searchParams.set('partner_id', partnerId);
  url.searchParams.set('q', searchQuery);
  url.searchParams.set('cmp', cmp);

  return url.toString();
}
